
export const styles = (theme, isMobile) => ({
  headerContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: isMobile? "space-around":"space-between",
    paddingLeft: isMobile? "1vw" : "2vw",
    paddingRight: isMobile? "1vw" : "2vw",
    alignItems: "center",
    backgroundColor: theme.background.primary,
    fontSize: "1rem",
    maxWidth: "100%",
    paddingTop: "1.5rem",
    paddingBottom: "0rem",
  },
  tagMenu:{
    display: 'flex',
    flexWrap: 'nowrap',
    whiteSpace: 'nowrap'
  },
  whiteLogo: {
    width: "15rem",
    justifySelf: "center",
  },
  badge: {
    minWidth: "13%",
    display: "flex",
    height: "3rem",
    alignText: "center",
    marginLeft: "2vw",
    justifyContent: isMobile? "center":"space-between",
    paddingLeft: "0.5%",
    paddingRight: "1%",
    backgroundColor: theme.background.secondary,
    color: theme.color.text.primary,
    borderRadius: 30,
    alignItems: "center",
  },
  roundIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "2rem",
    height: "2rem",
    borderRadius: 50,
    backgroundColor: theme.background.primary,
  },
  icon:{
    height: "60%",
    width: "60%",
  },
  container: {
    backgroundColor: theme.background.primary,
    color: theme.color.text.primary,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    listStyleType: "none",
  },
  menuItem: {
    backgroundColor: theme.background.primary,
    color: theme.color.text.primary,
  },
  separator: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  button: {
    backgroundColor: theme.background.secondary,
    marginLeft: "10px",
    padding: "10px",
    borderRadius: "5px",
  },
});